// @flow

import { Shop } from './Shop'

// @deprecated
export const Channel = Shop
